export const device = {
  tablet: '(max-width: 1200px)',
  desktop: '(min-width: 1200px)'
};
